import { render, staticRenderFns } from "./wallet-payment.vue?vue&type=template&id=08af3578&scoped=true"
import script from "./wallet-payment.vue?vue&type=script&lang=js"
export * from "./wallet-payment.vue?vue&type=script&lang=js"
import style0 from "./wallet-payment.vue?vue&type=style&index=0&id=08af3578&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08af3578",
  null
  
)

export default component.exports